module.exports = __webpack_public_path__ + "img/Route596.399d0523.png";